import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import { Play, ArrowRight, ArrowLeft, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import event_1 from "../../assets/images/event_1.jpg"
import event_2 from "../../assets/images/event_2.jpg"
import event_3 from "../../assets/images/event_3.jpg"
import event_4 from "../../assets/images/event_4.jpg"
const pastEvents = [
    {
        id: "evt-past-01",
        tag: "Main Keynote",
        title: "Autonomous Enterprise Keynote: The Shift Beyond Legacy BPM",
        description:
            "Watch architectural leaders and core practice directors break down how autonomous Zeebe micro-workers and event streaming meshes are redefining multi-modal enterprise automation.",
        image:
            event_2,
        watchLink: "#watch-keynote",
        duration: "45 mins",
    },
    {
        id: "evt-past-02",
        tag: "Technical Deep-Dive",
        title: "Governing LLMs with Deterministic DMN Decision Matrices",
        description:
            "A hands-on breakdown demonstrating how enterprise compliance standards (CMS-0057-F & SOC2) are enforced through non-bypassable decision tables prior to database write operations.",
        image:
            event_3,
        watchLink: "#watch-governance",
        duration: "55 mins",
    },
    {
        id: "evt-past-03",
        tag: "Engineering Lab",
        title: "High-Throughput FHIR & HL7 Prior-Authorization at Scale",
        description:
            "Discover how Tier-1 health systems cut authorization latency from 72 hours to sub-minute straight-through approvals with zero manual portal interventions.",
        image:
            event_1,
        watchLink: "#watch-healthcare",
        duration: "40 mins",
    },
    {
        id: "evt-past-04",
        tag: "Cloud Migration",
        title: "Legacy Reim(AI)gined: Strangler-Fig Patterns for Core Banking",
        description:
            "A pragmatic look at wrapping AS/400 mainframes with low-latency Kafka event envelopes, safely moving high-concurrency ledger operations to the cloud.",
        image:
            event_4,
        watchLink: "#watch-banking",
        duration: "50 mins",
    },
];
export default function PastEvents() {
    return (
        <section className="relative w-full bg-[#EBF4FA] py-16 md:py-24 px-4 sm:px-6 lg:px-12 overflow-hidden font-sans">

            <div className="mb-16 flex max-w-4xl mx-auto flex-col items-center text-center md:mb-20">
                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="mb-4 inline-flex items-center gap-2 rounded-full  px-3.5 py-1.5 backdrop-blur-md"
                >
                    <span className="text-[11px] font-bold uppercase tracking-[0.2em] px-6 lg:px-0 text-slate-700">
                        ON-DEMAND SESSIONS & KEYNOTES
                    </span>
                </motion.div>
                <motion.h2
                    initial={{ opacity: 0, y: 15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.08 }}
                    className="font-display text-3xl sm:text-4xl md:text-5xl font-bold px-6 lg:px-0 tracking-tight text-slate-950 "
                >
                    Watch Our Past  <span className="italic font-serif font-normal text-[#5dc9f0]">
                        Events
                    </span>{" "}
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0, y: 15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.15 }}
                    className="mt-5 max-w-2xl text-base font-normal leading-relaxed px-6 lg:px-0 text-slate-600 sm:text-lg"
                >
                    Missed a live session? Stream our full keynote broadcasts, technical
                    whiteboard sessions, and architecture teardowns anytime.
                </motion.p>
            </div>
            {/* Swiper Slider Wrapper */}
            <div className="max-w-7xl mx-auto relative px-2 sm:px-8">
                <Swiper
                    modules={[Navigation, Pagination, EffectCoverflow]}
                    effect={"coverflow"}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={"auto"}
                    loop={true}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 0,
                        depth: 100,
                        modifier: 2.5,
                        slideShadows: false,
                    }}
                    navigation={{
                        prevEl: ".prev-event-btn",
                        nextEl: ".next-event-btn",
                    }}
                    pagination={{
                        clickable: true,
                        el: ".custom-swiper-pagination",
                    }}
                    className="!overflow-visible py-4"
                >
                    {pastEvents.map((event) => (
                        <SwiperSlide
                            key={event.id}
                            className="!w-[90%] sm:!w-[640px] md:!w-[760px] lg:!w-[880px] select-none transition-all duration-300"
                        >
                            <div className="relative rounded-[2rem] p-4 sm:p-6 md:p-8 overflow-hidden shadow-2xl border border-white/40  text-white">
                                <div
                                    className="pointer-events-none absolute top-0 left-0 w-full h-full"
                                    style={{
                                        background:
                                            "linear-gradient(136deg, #62d4f7 0%, #5dc9f0 20%, #3579be 60%",
                                    }}
                                />
                                <div className="relative z-10 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-center">
                                    <div className="md:col-span-5 relative w-full h-[220px] sm:h-[260px]  md:h-[300px] lg:h-[400px] overflow-hidden rounded-[1.5rem] md:rounded-tr-[3.5rem] shadow-lg border border-white/20">
                                        <img
                                            src={event.image}
                                            alt={event.title}
                                            className="w-full h-full object-cover object-center"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                                       
                                        <span className="absolute bottom-3 left-3 text-[11px] font-semibold bg-black/60 backdrop-blur-md text-white px-2.5 py-1 rounded-full border border-white/10 flex items-center gap-1.5">
                                            <Play className="w-3 h-3 fill-white" />
                                            {event.duration}
                                        </span>
                                    </div>                               
                                    <div className="md:col-span-7 flex flex-col justify-between space-y-6">
                                        <div className="inline-block">
                                            <span className="text-xs uppercase tracking-wider font-extrabold text-white/90 bg-white/20 px-3 py-1 rounded-full backdrop-blur-sm border border-white/20">
                                                {event.tag}
                                            </span>
                                        </div>
                                        <h3 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white leading-snug">
                                            {event.title}
                                        </h3>
                                        <p className="text-white/85 text-xs sm:text-sm md:text-base leading-relaxed line-clamp-3">
                                            {event.description}
                                        </p>
                                        <div className="pt-2">
                                            <a
                                                href="/#"
                                                className="group relative inline-flex items-center justify-between rounded-full gap-3 px-6 py-2 border border-black/15 bg-[#ffffff] text-[#000036] hover:text-white hover:bg-[#000036] font-mono text-sm font-semibold capitalize tracking-widest transition-all duration-300 hover:shadow-lg"
                                            >
                                                <span>Watch Now</span>
                                                <div className="h-7 w-7 rounded-full bg-white/10 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5 group-hover:bg-slate-700 group-hover:text-white">
                                                    <ArrowUpRight size={15} />
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="flex items-center justify-between mt-8 max-w-xs mx-auto">
                    <button
                        aria-label="Previous event"
                        className="prev-event-btn w-10 h-10 rounded-full bg-white border border-slate-300 text-slate-800 flex items-center justify-center hover:bg-[#000036] hover:text-white  transition shadow-sm cursor-pointer"
                    >
                        <ArrowLeft className="w-4 h-4" />
                    </button>
                    <div className="custom-swiper-pagination flex justify-center !w-auto !gap-2" />
                    <button
                        aria-label="Next event"
                        className="next-event-btn w-10 h-10 rounded-full bg-white border border-slate-300 text-slate-800 flex items-center justify-center hover:bg-[#000036] hover:text-white transition shadow-sm cursor-pointer"
                    >
                        <ArrowRight className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </section>
    );
}